function bindSearchSpinner(formId, iconId, spinnerId, inputId) {
  var form = document.getElementById(formId);
  if (!form || form._spinnerBound) return;
  form._spinnerBound = true;

  form.addEventListener("submit", function(e) {
    var icon = document.getElementById(iconId);
    var spinner = document.getElementById(spinnerId);
    var input = document.getElementById(inputId);
    if (icon && spinner && input && input.value.trim().length >= 2) {
      e.preventDefault();
      icon.classList.add("d-none");
      spinner.classList.remove("d-none");
      input.readOnly = true;
      setTimeout(function() { form.submit(); }, 50);
    }
  });
}

function initSearchSpinner() {
  bindSearchSpinner("search-form", "search-icon", "search-spinner", "search-input");
  bindSearchSpinner("home-search-form", "home-search-icon", "home-search-spinner", "home-search-input");
}

document.addEventListener("turbo:load", initSearchSpinner);
document.addEventListener("DOMContentLoaded", initSearchSpinner);
